"use client";

import { cn, getColors } from "@/lib/utils/utils";
import Flex from "./flex";
import { memo } from "react";
interface BalanceColorProps {
  className?: string;
  leftColor: string;
  rightColor: string;
}

const BalanceColor: React.FC<BalanceColorProps> = memo(
  ({ className, leftColor, rightColor }) => {
    return (
      <Flex className={cn("h-2", className)}>
        <div className={cn("flex-1 h-full", getColors({ color: leftColor }))} />
        <div
          className={cn("flex-1 h-full", getColors({ color: rightColor }))}
        />
      </Flex>
    );
  }
);
export default BalanceColor;
